import InstallationStudyPage from './InstallationStudyPage';

export default InstallationStudyPage;
